import { computed, resource, Service } from '@angular/core';
import Polygon from '@arcgis/core/geometry/Polygon';
import { execute as getCentroid } from '@arcgis/core/geometry/operators/centroidOperator.js';
import { outagesPolygonLayer } from './layers/outages.layer';
import { Coordinates, PowerOutage, PowerOutageResponse } from './models/power-outage.model';

@Service()
export class PowerOutageService {
  /**
   * Fetches power outage data from the ArcGIS Feature Layer.
   */
  powerOutagesResource = resource({
    loader: async () => {
      try {
        const response = await outagesPolygonLayer.queryFeatures();

        return response.features
          .map(item => {
            const polygon = item.geometry as Polygon;
            const attributes = item.attributes as PowerOutageResponse;
            const centroid = getCentroid(polygon);

            const coordinates: Coordinates = {
              x: centroid.x,
              y: centroid.y,
            };

            return this.mapPowerOutage(attributes, coordinates);
          })
          .sort((a, b) => (b.municipality < a.municipality ? 1 : -1));
      } catch (error) {
        console.error('Failed to fetch power outage data:', error);
        throw error;
      }
    },
  });

  readonly outages = computed(() => this.powerOutagesResource.value() ?? []);

  private mapPowerOutage(attributes: PowerOutageResponse, coordinates: Coordinates): PowerOutage {
    return {
      id: attributes.OBJECTID,
      affectedCustomers: attributes.antallkunder ?? 0,
      type: attributes.avbruddstype ?? 'Unplanned',
      city: attributes.poststed ?? '',
      coordinates: coordinates,
      municipality: attributes.kommune ?? '',
      plannedRectifyEnd: attributes.utkoblingslutt ? new Date(attributes.utkoblingslutt) : null,
      plannedRectifyStart: attributes.utkoblingstart ? new Date(attributes.utkoblingstart) : null,
      unplannedRegisteredDate: attributes.strombruddoppdaget
        ? new Date(attributes.strombruddoppdaget)
        : null,
    };
  }
}
